// Imports
import { useCallback } from 'react';
import { Stripe } from '@stripe/stripe-js';
import useStoredPaymentMethodSubmission from './use-stored-payment-method-submission';


// Define the accepted options
interface Options {
	stripeAccountID: string;
	selectedBankID: string;
	onSuccess: () => void;
}


// A hook that handles confirming a US bank account payment using Stripe
const useBankAccountPayment = ({ stripeAccountID, selectedBankID, onSuccess }: Options) => {
	// Build the Stripe confirmation callback for bank accounts
	const confirm = useCallback(
		(stripe: Stripe, clientSecret: string) => {
			return stripe.confirmUsBankAccountPayment(clientSecret, {
				payment_method: selectedBankID,
			});
		},
		[selectedBankID]
	);
	
	
	// Delegate to the shared submission hook
	return useStoredPaymentMethodSubmission({
		stripeAccountID,
		confirm,
		onSuccess,
	});
};

export default useBankAccountPayment;
